import { isDev, isProd, isUAT } from "../config/env";

export const getEnvString = (): string => {
  if (isDev) {
    return "DEV";
  }
  if (isUAT) {
    return "UAT";
  }
  if (isProd) {
    return "PROD";
  }
  return "UNKNOWN";
};
